import { Controller } from "react-hook-form";
import { FormHelperText, FormLabel, TextField } from "@material-ui/core";

import useStyles from "../styles";

import { TextInputProps } from "./text-input.props";

export const TextInput = (props: TextInputProps) => {
  const classes = useStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;

  const { fullWidth = true, placeholder = "", required = false } = props;

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <label className={classes.fieldWrapper}>
          <FormLabel
            className={classes.label}
            component="span"
            error={hasError}
            required={required}
          >
            {props.label}
          </FormLabel>
          <TextField
            {...renderProps.field}
            error={hasError}
            fullWidth={fullWidth}
            placeholder={placeholder}
            variant="outlined"
          />
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </label>
      )}
    />
  );
};
